export const GEO_REGION = "/v1/master-data/geo-region/";
export const ADD_REGION = "/v1/master-data/geo-region/";
export const UPDATE_REGION = "/v1/master-data/geo-region/";
export const TOGGLE_REGION = "/v1/master-data/geo-region/";
export const GEO_REGION_ACTIVE_LIST = "/v1/master-data/geo-region/active/list";

export const TASK_CATEGORY = "/v1/master-data/task-category/";

export const TASK_TERM = "/v1/master-data/task-term/";

export const SUB_MODULE = "/v1/master-data/module/sub/";

export const INVENTORY_SETUP = "/v1/master-data/inventory-setup/";
export const INVENTORY_SETUP_ACTIVE_LIST = "/v1/master-data/inventory-setup/active/list";

export const TLM_MASTER = "/v1/master-data/tlm-master/";
export const TLM_MASTER_ACTIVE_LIST = "/v1/master-data/tlm-master/active/list";

export const CURRICULUM = "/v1/content/curriculum/";

// Curriculum Master API routes
export const CURRICULUM_MASTER = "/v1/master-data/curriculum-master/";
export const CURRICULUM_MASTER_DETAIL =
  "/v1/master-data/curriculum-master/detail/";
export const MODULE_LIST = "/v1/master-data/module/";
export const SUBMODULE_LIST = "/v1/master-data/module/sub/";
export const APPLICABLE_GRADES = "/v1/content/curriculum/";

export const INVOICE_CODE = "/v1/master-data/invoice-codes/";
export const INVOICE_CODE_ACTIVE_LIST = "/v1/master-data/invoice-codes/active/list";


// KIT API routes
export const CREATE_KIT = "/v1/master-data/kit/";
export const KIT_DETAIL = "/v1/master-data/kit/";
export const KIT_LIST = "/v1/master-data/kit/";
export const UPDATE_KIT = "/v1/master-data/kit/";
export const TOGGLE_KIT = "/v1/master-data/kit/";
export const KIT_ACTIVE_LIST = "/v1/master-data/kit/active/list";
export const GET_CHECK_LIST = "/v1/school/inventory/checklist/"
export const GET_CHECK_STATUS_LIST = "/v1/school/inventory/status/"
export const UPDATE_CHECK_LIST = "/v1/school/inventory/checklist/"